import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-direction: column;
  .loaderWrapper {
    position: relative; 
    margin: auto;
    margin-left: 5px; 
    margin-top: 19px; 
    margin-right: 5px;
    .loader {
      top: -50% !important;
    }
 }
`